import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const LiabilitiesField = ({ assetsLiabilitiesSelectOptions }) => {
  return (
    <Field name="liabilities" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Liabilities</label>
          <Select {...input} multi options={assetsLiabilitiesSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

LiabilitiesField.propTypes = {
  assetsLiabilitiesSelectOptions: PropTypes.array.isRequired,
};

export default LiabilitiesField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/LiabilitiesField.jsx